module.exports = __webpack_public_path__ + "img/story019.05c5b2e5.webp";